import { Component } from '@angular/core';


@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
  styles: ['.active { background-color: #eef; }']
  
})
export class HomeComponent {
}
